import drawsApi from '@/services/api/draws'

export default {
  namespaced: true,
  state: () => ({
    event: {},
    infoLoading: false,
    infoRequestId: 0,
    rounds: [],
    draws: [],
    meta: {},
    loading: false,
    requestId: 0
  }),
  mutations: {
    START_INFO(state) {
      state.infoRequestId += 1
      state.infoLoading = true
      state.event = {}
      state.rounds = []
    },
    RECEIVE_INFO(state, data) {
      state.event = data.event || {}
      state.rounds = data.rounds || []
    },
    FINISH_INFO(state) {
      state.infoLoading = false
    },
    START(state) {
      state.requestId += 1
      state.loading = true
    },
    RECEIVE(state, data) {
      state.draws = data.draws || []
      state.meta = data.meta || {}
    },
    FINISH(state) {
      state.loading = false
    }
  },
  actions: {
    async fetchInfo({ state, commit }, eventId) {
      commit('START_INFO')
      const requestId = state.infoRequestId
      try {
        const res = await drawsApi.getPublicDrawsInfo(eventId)
        if (requestId === state.infoRequestId) commit('RECEIVE_INFO', res.data.data)
      } catch (_) {
        // The shared HTTP interceptor displays the backend error.
      } finally {
        if (requestId === state.infoRequestId) commit('FINISH_INFO')
      }
    },
    async fetch({ state, commit }, { eventId, round, page, perPage }) {
      commit('START')
      const requestId = state.requestId
      try {
        const res = await drawsApi.getPublicDraws(eventId, round, { page, per_page: perPage })
        if (requestId === state.requestId) commit('RECEIVE', res.data.data)
      } catch (_) {
        if (requestId === state.requestId) commit('RECEIVE', {})
      } finally {
        if (requestId === state.requestId) commit('FINISH')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/publicDraws.js